import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { cn } from 'lib/utils';
import { TONE_CLASSES } from 'components/admin/audit/pillTone';
import { realignedSector, realignResult, textOr } from 'utils/auditLabels';
import type { AdminAuditEvent } from 'api/adminAuditApi';
import { MUTED_CELL } from './tableColumns';

/** A realigned ticket's columns after the time (8b): key · store · move, result pill, failure reason. */
const RealignChildCells = ({ event, link }: { event: AdminAuditEvent; link: string | null }) => {
  const { t } = useTranslation();
  const { from, to } = realignedSector(event);
  const result = realignResult(t, event);
  const error = textOr(event.context?.error);

  return (
    <>
      <span role="cell" className="col-span-3 flex min-w-0 items-center gap-3 text-[13px]">
        {link ? (
          <Link to={link} onClick={(e) => e.stopPropagation()} className="shrink-0 font-mono underline hover:no-underline">
            {event.entityId}
          </Link>
        ) : (
          <span className="shrink-0 font-mono">{event.entityId}</span>
        )}
        <span className={`min-w-0 truncate ${MUTED_CELL}`}>{textOr(event.context?.store)}</span>
        <span className="shrink-0 whitespace-nowrap font-mono text-[12px]">{`${from} → ${to}`}</span>
      </span>
      <div role="cell">
        <span className={cn('inline-flex h-[22px] items-center rounded-full px-2.5 text-[11.5px] font-medium', TONE_CLASSES[result.failed ? 'rose' : 'emerald'])}>
          {result.label}
        </span>
      </div>
      <span role="cell" title={error} className={cn('truncate text-[12.5px]', result.failed ? 'text-rose-600 dark:text-rose-400' : MUTED_CELL)}>
        {error}
      </span>
    </>
  );
};

export default RealignChildCells;
